var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.autoLabel.length)?_c('base-label',{staticClass:"mt-0 truncate"},[_vm._v(_vm._s(_vm.autoLabel))]):_c('base-label',{staticClass:"mt-0 truncate"},[_vm._v("\n  "+_vm._s(_vm.element.pivot.label || 'Repeater')+" Item "+_vm._s(_vm.itemId)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }